var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"1.167.3"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/_hub";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import getConfig from 'next/config';
import { APP_NAME } from './src/libs/constants';

const { publicRuntimeConfig } = getConfig();

if (publicRuntimeConfig.sentryEnable) {
  console.log('Loading sentry client config');

  Sentry.init({
    dsn: publicRuntimeConfig.sentryDsn || 'https://db1b225d016a4e52bbf42d3ababc63e2@o263529.ingest.sentry.io/5582611',
    environment: publicRuntimeConfig.envName,
    release: ['local', 'testing'].includes(publicRuntimeConfig.envName)
      ? publicRuntimeConfig.envName
      : publicRuntimeConfig.version,
    tunnel: `/_${APP_NAME}/api/sentry-tunnel`,
    tracesSampleRate: publicRuntimeConfig.envName === 'orange' ? 0.002 : 0,

    allowUrls: publicRuntimeConfig.i18n.domains
      .map(config => config.domain)
      .filter(domain => !domain.endsWith('.test')),

    // Ignore common browser errors and noise
    ignoreErrors: [
      // Network errors
      'AbortError',
      'NetworkError',
      'Failed to fetch',
      'Network request failed',
      'Load failed',

      // Browser extension errors
      /^Non-Error promise rejection captured/i,
      /Extension context invalidated/i,

      // ResizeObserver errors (common noise)
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',

      // Hydration errors (often benign)
      /Hydration failed because the initial UI does not match/i,
      /There was an error while hydrating/i,

      // Cancelled requests
      'The user aborted a request',
      'Request aborted',

      // Browser navigation errors
      'cancelled',
      'The operation was aborted',
    ],

    beforeSend(event, hint) {
      event.tags = {
        ...event.tags,
        app: APP_NAME,
        version: publicRuntimeConfig.version,
      };

      if (event.exception?.values?.[0]?.stacktrace?.frames) {
        const frames = event.exception.values[0].stacktrace.frames;
        const hasChromeExtension = frames.some(
          frame => frame.filename?.includes('chrome-extension://') || frame.filename?.includes('moz-extension://')
        );
        if (hasChromeExtension) {
          return null;
        }
      }

      // Add readable error context
      if (hint.originalException instanceof Error) {
        event.contexts = {
          ...event.contexts,
          error_details: {
            name: hint.originalException.name,
            message: hint.originalException.message,
          },
        };
      }

      return event;
    },

    maxBreadcrumbs: 50,
    normalizeDepth: 5,
  });

  const setUserContext = () => {
    try {
      const locale = document.documentElement.lang;
      if (locale) {
        Sentry.setContext('locale', { language: locale });
      }
    } catch (e) {}
  };

  setUserContext();
}
